
document.addEventListener('DOMContentLoaded', () => {
  const mainContent = document.querySelector('.drw-Drawer_MatchMyMakeupContent-mmmContent')
  const landingTemplate = `
        <div id="mmm-landing-page">
            <p>Want to know your shade in all of our products? Click START NOW! </p>
            <button id="openQRFrame">Start now</button>
        </div>
    `

  mainContent.style.display = 'none'
  mainContent.insertAdjacentHTML('beforebegin', landingTemplate)
  document.getElementById('openQRFrame').addEventListener('click', () => {
    document.getElementById('mmm-landing-page').style.display = 'none'
    loadQRFrame({ event_id: 'qrStart' })
    document.getElementById('shade-finder').style.overflow = ''
    document.querySelector("footer[data-section-id='footer']").style.position = 'relative'
  })
})

window.addEventListener('load', () => {
  function optimizeDisplay () {
    document.querySelector('html').style.backgroundColor = '#ffffff'
  }
  optimizeDisplay()
})

function loadQRFrame (message) {
  const parentElement = document.getElementById('mmm-landing-page').parentElement
  const landingPage = document.getElementById('mmm-landing')
  if (landingPage === null) {
    const iframe = createQRFrame(message)
    parentElement.prepend(iframe)
  } else {
    landingPage.src = landingPage.src
    landingPage.contentWindow.postMessage(product_message, '*')
    if (typeof message !== 'undefined') {
      landingPage.contentWindow.postMessage(message, '*')
    }
  }
}

function createQRFrame (message) {
  const iframe = document.createElement('iframe')
  const cid = 'UmVmeSBCZWF1dHk='
  iframe.src = `https://www.matchmymakeup.com/client/at/store/${cid}`
  iframe.id = 'mmm-landing'
  iframe.classList.add('relative')
  iframe.style.overflow = 'hidden'
  iframe.height = '600px'
  iframe.width = '100%'
  iframe.frameBorder = '0'
  iframe.allow = 'camera'
  iframe.addEventListener('load', () => {
    iframe.contentWindow.postMessage(product_message, '*')
    if (typeof message !== 'undefined') {
      iframe.contentWindow.postMessage(message, '*')
    }
  })
  return iframe
}
